import { MOVIE_REQUEST, MOVIE_SUCCESS, MOVIE_FAILURE, CLEAR_MOVIE } from "./types";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export default function movieReducer(state = initialState, action) {
  switch (action.type) {
    case MOVIE_REQUEST:
      return { ...state, loading: true, error: null };
    case MOVIE_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case MOVIE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CLEAR_MOVIE:
      return initialState;
    default:
      return state;
  }
}
